import * as React from 'react';
import EmailFooterV2 from '../components/FooterV2';
import { companyConfig } from '../config/colors';

interface PasswordResetEmailProps {
  name?: string;
  resetLink?: string;
  expirationHours?: number;
}

export const PasswordResetEmail: React.FC<PasswordResetEmailProps> = ({
  name = 'João Silva',
  resetLink = 'https://trivium.com.br/reset-password/abc123',
  expirationHours = 24,
}) => {
  return (
    <div style={containerStyle}>
      <table width="100%" border="0" cellSpacing="0" cellPadding="0" style={tableStyle}>
        <tr>
          <td align="center">
            <table width="600" border="0" cellSpacing="0" cellPadding="0" style={innerTableStyle}>
              {/* Header */}
              <tr>
                <td align="center" style={headerStyle}>
                  <img 
                    src="https://asset.brandfetch.io/idNdb_MPJ2/idFGj2lq6u.png?c=1dxbfHSJFAPEGdCLU4o5B" 
                    alt="Trivium" 
                    width="120" 
                    style={logoStyle} 
                  />
                </td>
              </tr>
              {/* Body */}
              <tr>
                <td style={bodyStyle}>
                  <p style={resetBadgeStyle}>🔐 Redefinição de Senha</p>
                  <h1 style={titleStyle}>Olá, {name}! 👋</h1>
                  <p style={messageStyle}>
                    Recebemos uma solicitação para redefinir sua senha na plataforma {companyConfig.name}.<br />
                    Clique no botão abaixo para criar uma nova senha.
                  </p>
                  <a href={resetLink} style={buttonStyle}>Redefinir Senha</a>
                  <p style={expirationStyle}>
                    Este link expira em {expirationHours} horas por motivos de segurança.
                  </p>
                </td>
              </tr>
              {/* Footer */}
              <tr>
                <td align="center">
                  <EmailFooterV2 variant="clean" showContactInfo={true} />
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  );
};

// Estilos
const containerStyle = {
  margin: '0',
  padding: '0',
  fontFamily: 'Arial, sans-serif',
  backgroundColor: '#f7f7f7',
};

const tableStyle = {
  backgroundColor: '#f7f7f7',
  padding: '40px 0',
};

const innerTableStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  overflow: 'hidden',
};

const headerStyle = {
  backgroundColor: '#1F1746',
  padding: '20px',
};

const logoStyle = {
  display: 'block',
};

const bodyStyle = {
  padding: '40px 30px',
  textAlign: 'center',
  color: '#333333',
};

const resetBadgeStyle = {
  backgroundColor: '#fef3c7',
  color: '#92400e',
  display: 'inline-block',
  padding: '8px 16px',
  borderRadius: '6px',
  fontSize: '14px',
  margin: '0 0 20px',
};

const titleStyle = {
  fontSize: '24px',
  margin: '0 0 10px',
  color: '#111111',
};

const messageStyle = {
  fontSize: '16px',
  margin: '0 0 30px',
  color: '#555555',
};

const buttonStyle = {
  backgroundColor: '#1F1746',
  color: '#ffffff',
  textDecoration: 'none',
  padding: '14px 28px',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: 'bold',
  display: 'inline-block',
  marginBottom: '20px',
};

const expirationStyle = {
  fontSize: '14px',
  color: '#666666',
  margin: '0',
  fontStyle: 'italic',
};

export default PasswordResetEmail;
